import { terminologyConfig } from '../terminology/store';
const ClientConfig = terminologyConfig({

  client: {
    label:        'Client',
    emptyMessage: 'No clients found.',
  },

  cases: {
    label:           'Investors',
    pluralLabel:     'Investors',
    emptyMessage:    'No Investors found.',
    managementLabel: 'Investors Management',

    fields: {
      id:     'id',
      name:   'case_name',          
      number: 'case_matter_number', 
    },

    headerOptions: [
      { label: 'Name',        sortField: 'case_name'          },
      { label: 'Case Number', sortField: 'case_matter_number' },
    ],
  },


  sessions: {
    label:              'Session',
    pluralLabel:        'Sessions',
    emptyMessage:       'No sessions found.',
    selectCasePrompt:   'Select a case to view sessions.',
    depositionLabel:    'Deposition',
    editDepositionLabel:'Edit: Deposition',
    addDepositionLabel: 'Add Deposition',
    sessionOptionsLabel:'Session Options',
    backToCaseLabel:    'Back to Case',


    fields: {
      id:          'id',
      displayName: 'display_name',  
      sessionType: 'session_type', 
      createdAt:   'created_at',
      status:      'status',
      volume:      'volume',
    },

    headerOptions: [
      { label: 'Name', sortField: 'display_name' },
      { label: 'Type', sortField: 'session_type' },
      { label: 'Date', sortField: 'created_at'   },
    ],


    filterOptions: [
      { label: 'All',       match: null       },
      { label: 'Scheduled', match: 'pending'  },
      { label: 'Completed', match: 'finished' },
    ],


    statusDisplay: {
      pending:  'Scheduled',
      started:  'Active',
      finished: 'Completed',
    },


    category: {
      label: 'Session Type',
      options: [
        { value: 'deposition',   normalizedType: 'deposition',  label: 'Deposition',   route: 'add-deposition'  },
        { value: 'witness_prep', normalizedType: 'witness-prep', label: 'Witness Prep', route: 'add-witnessprep' },
        { value: 'trial',        normalizedType: 'trial',        label: 'Trial',        route: 'add-trial'       },
        { value: 'mediation',    normalizedType: 'mediation',    label: 'Mediation',    route: 'add-mediation'   },
        { value: 'arbitration',  normalizedType: 'arbitration',  label: 'Arbitration',  route: 'add-arbitration' },
      ],
    },

    types: {
      deposition: {
        label:              'Portfolio',
        managementLabel:    'Portfolio Management',
        fieldLabel:         'Portfolio Name',
        locationLabel:      'Location* (City of Nice)',
        relatedToLabel:     'Related To',
        reportingLeadLabel: 'Reporting Lead Name',
      },
      witness_prep: {
        label:              'Financial',
        managementLabel:    'Financial Management',
        fieldLabel:         'WiFinancialtness Name',
        locationLabel:      'Location* (City)',
        relatedToLabel:     'Related To',
        reportingLeadLabel: null,
      },
      trial: {
        label:              'Investment ',
        managementLabel:    'Investment Management',
        fieldLabel:         'Investment Name',
        locationLabel:      'Location* (City)',
        relatedToLabel:     'Related To',
        reportingLeadLabel: null,
      },
      mediation: {
        label:              'Management',
        managementLabel:    'Management',
        fieldLabel:         'Management Name',
        locationLabel:      'Location* (City)',
        relatedToLabel:     'Related To',
        reportingLeadLabel: null,
      },
      arbitration: {
        label:              'Investment Evaluation',
        managementLabel:    'Evaluation Management',
        fieldLabel:         'Evaluation Name',
        locationLabel:      'Location* (City of Arbitration)',
        relatedToLabel:     'Related To',
        reportingLeadLabel: null,
      },
      // custom sessions: label is dynamic (comes from s.custom_type on each record)
      custom: {
        label:              'Custom Session',               // fallback when custom_type is empty
        managementLabel:    'Custom Session Management',
        fieldLabel:         'Session Name',
        locationLabel:      'Location* (City)',
        relatedToLabel:     'Related To',
        reportingLeadLabel: null,
      },
    },
  },

  // ─── Folders ──
  folders: {
    label:          'Folder',
    pluralLabel:    'Folders',
    emptyMessage:   'No folders found.',
    addLabel:       'Add Folder',
    renameLabel:    'Rename Folder',
    defaultLabel:   'Default',
    selectAllLabel: 'Select All',
  },

  // ─── Documents ───
  documents: {
    label:               'Document',
    pluralLabel:         'Documents',
    emptyMessage:        'No documents in this folder.',
    addLabel:            'Add Documents',
    addPlaceholderLabel: 'Add Placeholder',
    placeholderText:     'Placeholder',
    selectFolderPrompt:  'Please select a folder to view documents',
  },

  // ─── User Management ──────────────────────────────────────────────────────
  users: {
    label:           'User',
    pluralLabel:     'Users',
    emptyMessage:    'No users found.',
    managementLabel: 'User Management',
  },

  // ─── Nav tabs (ClientDashboard) ───────────────────────────────────────────
  nav: {
    cases:   { label: 'Investor Management', icon: 'folder-fill'       },
    users:   { label: 'User Management', icon: 'people-fill'       },
    account: { label: 'Account',         icon: 'person-lines-fill' },
  },

}, {
"sessions.types.deposition.label": ["deposition", "singular", "{name}"],
  "sessions.types.deposition.managementLabel": ["deposition", "singular", "{name} Management"],
  "sessions.types.deposition.fieldLabel": ["deposition", "singular", "{name} Name"],
  "sessions.types.witness_prep.label": ["witnessPrep", "singular", "{name}"],
  "sessions.types.witness_prep.managementLabel": ["witnessPrep", "singular", "{name} Management"],
  "sessions.types.witness_prep.fieldLabel": ["witnessPrep", "singular", "{name} Name"],
  "sessions.types.trial.label": ["trial", "singular", "{name}"],
  "sessions.types.trial.managementLabel": ["trial", "singular", "{name} Management"],
  "sessions.types.trial.fieldLabel": ["trial", "singular", "{name} Name"],
  "sessions.types.mediation.label": ["mediation", "singular", "{name}"],
  "sessions.types.mediation.managementLabel": ["mediation", "singular", "{name} Management"],
  "sessions.types.mediation.fieldLabel": ["mediation", "singular", "{name} Name"],
  "sessions.types.arbitration.label": ["arbitration", "singular", "{name}"],
  "sessions.types.arbitration.managementLabel": ["arbitration", "singular", "{name} Management"],
  "sessions.types.arbitration.fieldLabel": ["arbitration", "singular", "{name} Name"],
  "sessions.category.options.0.label": ["deposition", "singular", "{name}"],
  "sessions.category.options.1.label": ["witnessPrep", "singular", "{name}"],
  "sessions.category.options.2.label": ["trial", "singular", "{name}"],
  "sessions.category.options.3.label": ["mediation", "singular", "{name}"],
  "sessions.category.options.4.label": ["arbitration", "singular", "{name}"],
  "sessions.depositionLabel": ["deposition", "singular", "{name}"],
  "sessions.editDepositionLabel": ["deposition", "singular", "Edit: {name}"],
  "sessions.addDepositionLabel": ["deposition", "singular", "Add {name}"],

  "client.label": [
    "client",
    "singular",
    "{name}"
  ],
  "client.singular": [
    "client",
    "singular",
    "{name}"
  ],
  "client.plural": [
    "client",
    "plural",
    "{name}"
  ],
  "client.pluralLabel": [
    "client",
    "plural",
    "{name}"
  ],
  "client.pageHeading": [
    "client",
    "plural",
    "{name}"
  ],
  "client.managementLabel": [
    "client",
    "singular",
    "{name} Management"
  ],
  "client.emptyMessage": [
    "client",
    "plural",
    "No {name} found."
  ],
  "cases.label": [
    "case",
    "singular",
    "{name}"
  ],
  "cases.singular": [
    "case",
    "singular",
    "{name}"
  ],
  "cases.plural": [
    "case",
    "plural",
    "{name}"
  ],
  "cases.pluralLabel": [
    "case",
    "plural",
    "{name}"
  ],
  "cases.pageHeading": [
    "case",
    "plural",
    "{name}"
  ],
  "cases.managementLabel": [
    "case",
    "singular",
    "{name} Management"
  ],
  "cases.emptyMessage": [
    "case",
    "plural",
    "No {name} found."
  ],
  "sessions.label": [
    "businessSession",
    "singular",
    "{name}"
  ],
  "sessions.singular": [
    "businessSession",
    "singular",
    "{name}"
  ],
  "sessions.plural": [
    "businessSession",
    "plural",
    "{name}"
  ],
  "sessions.pluralLabel": [
    "businessSession",
    "plural",
    "{name}"
  ],
  "sessions.pageHeading": [
    "businessSession",
    "plural",
    "{name}"
  ],
  "sessions.managementLabel": [
    "businessSession",
    "singular",
    "{name} Management"
  ],
  "sessions.emptyMessage": [
    "businessSession",
    "plural",
    "No {name} found."
  ],
  "users.label": [
    "clientUser",
    "singular",
    "{name}"
  ],
  "users.singular": [
    "clientUser",
    "singular",
    "{name}"
  ],
  "users.plural": [
    "clientUser",
    "plural",
    "{name}"
  ],
  "users.pluralLabel": [
    "clientUser",
    "plural",
    "{name}"
  ],
  "users.pageHeading": [
    "clientUser",
    "plural",
    "{name}"
  ],
  "users.managementLabel": [
    "clientUser",
    "singular",
    "{name} Management"
  ],
  "users.emptyMessage": [
    "clientUser",
    "plural",
    "No {name} found."
  ],
  "nav.cases.label": [
    "case",
    "singular",
    "{name} Management"
  ],
  "nav.users.label": [
    "clientUser",
    "singular",
    "{name} Management"
  ],
  "cases.headerOptions.1.label": [
    "case",
    "singular",
    "{name} Number"
  ],
  "sessions.selectCasePrompt": [
    "case",
    "singular",
    "Select a {name} to view sessions."
  ],
  "sessions.backToCaseLabel": [
    "case",
    "singular",
    "Back to {name}"
  ],
  "sessions.sessionOptionsLabel": [
    "businessSession",
    "singular",
    "{name} Options"
  ]
});

export default ClientConfig;